module.exports = __webpack_public_path__ + "img/sunburst.368b22a9.png";